/** Find a product in the catalog object by category slug + external id. */
import { normalizeProductCustomizationOptions } from '../pieceCustomization/pieceCustomization';

function normalizeProductHit(hit, category) {
  const customization_options = normalizeProductCustomizationOptions({
    customization_profile: hit.customization_profile,
    customization_options: hit.customization_options,
  });
  return { ...hit, category, customization_options };
}

function decodeProductId(raw) {
  const trimmed = String(raw || '').trim();
  if (!trimmed) return '';
  try {
    return decodeURIComponent(trimmed);
  } catch {
    return trimmed;
  }
}

export function findProductInCatalog(products, categorySlug, productId) {
  const cat = String(categorySlug || '').trim().toLowerCase();
  const id = decodeProductId(productId);
  if (!id) return null;

  if (cat) {
    const list = products?.[cat];
    if (Array.isArray(list)) {
      const hit = list.find((p) => String(p?.id || '').trim() === id);
      if (hit) return normalizeProductHit(hit, cat);
    }
  }

  // Fallback: id may be valid under a different category slug in the URL.
  for (const [slug, list] of Object.entries(products || {})) {
    if (!Array.isArray(list)) continue;
    const hit = list.find((p) => String(p?.id || '').trim() === id);
    if (hit) return normalizeProductHit(hit, slug);
  }

  return null;
}
